import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { CultureCardService } from '../service';
import {
	createCard,
	createCardFailure,
	createCardSuccess,
	createCategory,
	createCategoryFailure,
	createCategorySuccess,
	createGuide,
	createGuideFailure,
	createGuideSuccess,
	deleteCard,
	deleteCardFailure,
	deleteCardSuccess,
	deleteCategory,
	deleteCategoryFailure,
	deleteCategorySuccess,
	deleteGuide,
	deleteGuideFailure,
	deleteGuideSuccess,
	getCards,
	getCardsFailure,
	getCardsSuccess,
	getCardToUpdate,
	getCardToUpdateFailure,
	getCardToUpdateSuccess,
	getCategories,
	getCategoriesFailure,
	getCategoriesSuccess,
	getGuides,
	getGuidesFailure,
	getGuidesSuccess,
	searchCards,
	searchCategories,
	searchGuides,
	setSearchCardsResult,
	setSearchCategoriesResult,
	setSearchGuidesResult,
	updateCard,
	updateCardFailure,
	updateCardSuccess,
	updateCategory,
	updateCategoryFailure,
	updateCategorySuccess,
	updateGuide,
	updateGuideFailure,
	updateGuideSuccess,
} from './slice';

function* getGuidesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.getGuides(
			action.payload.page,
			action.payload.searchKey,
			action.payload.id,
		);
		yield put(getGuidesSuccess(data));
	} catch (e) {
		yield put(getGuidesFailure(e));
		console.error(e);
	}
}

function* createGuideHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.createGuide(action.payload.guide);
		yield put(createGuideSuccess({}));
		toast('Guide created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createGuideFailure(e));
		console.error(e);
	}
}

function* updateGuideHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.updateGuide(action.payload.guide);
		yield put(updateGuideSuccess({ data }));
		toast('Guide updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateGuideFailure(e));
		console.error(e);
	}
}

function* deleteGuideHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.deleteGuide(action.payload.guideId);
		yield put(deleteGuideSuccess({}));
		toast('Guide deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteGuideFailure(e));
		console.error(e);
	}
}

function* getCategoriesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.getCategories(
			action.payload.page,
			action.payload.searchKey,
			action.payload.id,
		);
		yield put(getCategoriesSuccess(data));
	} catch (e) {
		yield put(getCategoriesFailure(e));
		console.error(e);
	}
}

function* createCategoryHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.createCategory(action.payload.category);
		yield put(createCategorySuccess({}));
		toast('Category created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createCategoryFailure(e));
		console.error(e);
	}
}

function* updateCategoryHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.updateCategory(action.payload.category);
		yield put(updateCategorySuccess({ data }));
		toast('Category updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateCategoryFailure(e));
		console.error(e);
	}
}

function* deleteCategoryHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.deleteCategory(action.payload.categoryId);
		yield put(deleteCategorySuccess({}));
		toast('Category deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteCategoryFailure(e));
		console.error(e);
	}
}

function* searchGuidesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.searchGuides(action.payload.searchKey);
		yield put(setSearchGuidesResult({ guides: data }));
	} catch (e) {
		console.error(e);
	}
}

function* searchCategoriesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.searchCategories(action.payload.searchKey);
		yield put(setSearchCategoriesResult({ categories: data }));
	} catch (e) {
		console.error(e);
	}
}

function* getCardsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.getCards(action.payload);
		yield put(getCardsSuccess(data));
	} catch (e) {
		yield put(getCardsFailure(e));
		console.error(e);
	}
}

function* searchCardsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.searchCards(action.payload.searchKey);
		yield put(setSearchCardsResult({ cards: data }));
	} catch (e) {
		console.error(e);
	}
}

function* deleteCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.deleteCard(action.payload.cardId);
		yield put(deleteCardSuccess({}));
		toast('Cultural card deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteCardFailure(e));
		console.error(e);
	}
}

function* createCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.createCard(action.payload.card);
		yield put(createCardSuccess({}));
		toast('Cultural card created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(createCardFailure({}));
	}
}

function* getCardToUpdateHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		const data = yield service.getCard(action.payload.cardId);
		yield put(
			getCardToUpdateSuccess({
				card: data,
			}),
		);
	} catch (e) {
		yield put(getCardToUpdateFailure({}));
	}
}

function* updateCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new CultureCardService(globalApplicationContext);
		yield service.updateCard(action.payload.card);
		yield put(updateCardSuccess({}));
		toast('Cultural card updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateCardFailure({}));
	}
}

export function* cultureCardSaga(): Generator<any, any, any> {
	yield all([takeEvery(getGuides, getGuidesHandler)]);
	yield all([takeEvery(createGuide, createGuideHandler)]);
	yield all([takeEvery(updateGuide, updateGuideHandler)]);
	yield all([takeEvery(deleteGuide, deleteGuideHandler)]);
	yield all([takeEvery(searchGuides, searchGuidesHandler)]);

	yield all([takeEvery(getCategories, getCategoriesHandler)]);
	yield all([takeEvery(createCategory, createCategoryHandler)]);
	yield all([takeEvery(updateCategory, updateCategoryHandler)]);
	yield all([takeEvery(deleteCategory, deleteCategoryHandler)]);
	yield all([takeEvery(searchCategories, searchCategoriesHandler)]);

	yield all([takeEvery(getCards, getCardsHandler)]);
	yield all([takeEvery(searchCards, searchCardsHandler)]);
	yield all([takeEvery(deleteCard, deleteCardHandler)]);

	yield all([takeEvery(createCard, createCardHandler)]);
	yield all([takeEvery(getCardToUpdate, getCardToUpdateHandler)]);
	yield all([takeEvery(updateCard, updateCardHandler)]);
}
